module.exports = __webpack_public_path__ + "static/media/Young Change Makers.02e272a9.png";